import React, { useCallback, useEffect, useMemo, useState } from 'react';

import PropTypes from 'prop-types';

import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useLocation, useHistory } from 'react-router-dom';

import { Col, Row, Modal } from 'antd';
import {
  clearCandidates,
  clearGatherURL,
  getAllPortfolio,
  getGatherCanLoad,
} from '../../data/store/portfolio/portfolioActions';
import {
  getCurrency,
  getInstrumentsAll,
} from '../../data/store/instruments/instrumentsActions';

import { textSort } from '../../helpers/textSort';
import ClientPortfolioList from '../ClientOverview/ClientPortfolioList/ClientPortfolioList';
import ButtonAdd from '../../components/ButtonAdd/ButtonAdd';
import ModalNewPortfolio from '../../components/ModalNewPortfolio/ModalNewPortfolio';
import BattonOptimise from '../../components/BattonOptimise/BattonOptimise';
import PortfolioTab from '../ClientOverview/PortfolioTab/PortfolioTab';
import FooterHoldings from '../ClientOverview/FooterHoldings/FooterHoldings';
import ClientAssets from '../ClientOverview/PortfolioTab/ClientAssets';

import ModalNewSelectPortfolio from '../../components/ModalNewSelectPortfolio/ModalNewSelectPortfolio';
import { getNextColor } from '../../hooks/getNextColor';
import SessionService from '../../services/SessionService';
import './style.scss';

export const SortArrow = ({ direction }) => {
  return (
    <div className={'sortArroy'}>
      <svg
        viewBox="0 0 1024 1024"
        width="12px"
        height="11px"
        fill={
          direction === null
            ? '#00000091'
            : direction === 'up'
              ? '#fb7b34'
              : '#7E716D'
        }
      >
        <path d="M858.9 689L530.5 308.2c-9.4-10.9-27.5-10.9-37 0L165.1 689c-12.2 14.2-1.2 35 18.5 35h656.8c19.7 0 30.7-20.8 18.5-35z"></path>
      </svg>
      <svg
        viewBox="0 0 1024 1024"
        width="12px"
        height="11px"
        fill={
          direction === null
            ? '#00000091'
            : direction === 'down'
              ? '#fb7b34'
              : '#7E716D'
        }
      >
        <path d="M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z"></path>
      </svg>
    </div>
  );
};

const ClientSummary = ({ userId, theme }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { pathname, state } = useLocation();
  const { t } = useTranslation('');

  const {
    portfolioList: { list: portfolioList },
  } = useSelector((state) => state.portfolioReducer);

  useEffect(() => {
    const withoutColor = portfolioList?.filter((i) => !i.color);
    if (withoutColor?.length) {
      getNextColor(userId);
    }
  }, [userId, portfolioList]);

  const closeIframe = () => {
    dispatch(clearGatherURL());
    setOpenNjordaIFrame(null);
  };

  const subscrible = useCallback(
    (event) => {
      if (event) {
        let parsedData;
        try {
          parsedData =
            typeof event.data === 'string'
              ? JSON.parse(event.data)
              : event.data;
          if (parsedData?.msg?.includes('Collection completed')) {
            dispatch(getGatherCanLoad(userId));
          }
          if (parsedData?.event === 'done') {
            closeIframe();
          }
        } catch (err) {
          console.error('Error parsing event.data:', err);
        }
      }
    },
    [userId, dispatch, closeIframe],
  );

  useEffect(() => {
    window.addEventListener('message', subscrible);

    return () => {
      window.removeEventListener('message', subscrible);
    };
  }, [subscrible]);

  const njordaURL = useSelector((state) => state.portfolioReducer.njordaURL);
  const { isLoading } = useSelector((state) => state.portfolioReducer);
  const cashes = useSelector((state) => state.instrumentsReducer?.cashes?.list);
  const { currencyList } = useSelector((state) => state.instrumentsReducer);


  // const [switcher, setSwitcher] = useState(0);

  // const switchertext = ['TOTAL', 'SPLIT'];

  const [tabs, setTabs] = useState(1);

  // const handleClick = () => {
  //   const seter = switcher == 0 ? 1 : 0;
  //   setSwitcher(seter);
  // };

  const [selectedRowKeys, setSelectedRowKeys] = useState(null);
  const [selectedPortfolio, setSelectedPortfolio] = useState(null);
  const [openModalSelectNew, setOpenModalSelectNew] = useState(false);
  const [openModalNew, setOpenModalNew] = useState(false);

  const [openNjordaIFrame, setOpenNjordaIFrame] = useState(null);

  const closeModal = () => {
    setOpenModalNew(false);
  };

  const closeModalSelect = () => {
    setOpenModalSelectNew(false);
  };

  const footerData = useMemo(() => {
    if (!selectedPortfolio) return { total: 0 };
    const getCashInstrumentRate = (id) => {
      const cash = cashes?.find((i) => i.ID === id);
      return cash?.latest_value_sek;
    };
    let total = 0;
    if (tabs === 1) {
      [selectedPortfolio]?.forEach((item) => {
        total += item.portfolio_content.reduce(
          (acc, current) => acc + (current.is_excluded ? 0 : current.value),
          0,
        );
        total += item.unlisted_content.reduce(
          (acc, current) => acc + current.value,
          0,
        );
      });
    } else if (tabs === 2) {
      [selectedPortfolio]?.forEach((item) => {
        total +=
          item.portfolio_cashes?.reduce(
            (acc, current) =>
              acc +
              current.amount * getCashInstrumentRate(current.instrument_id),
            0,
          ) ?? 0;
      });
    } else if (tabs === 0) {
      if ([selectedPortfolio]?.length === 1)
        total = [selectedPortfolio]?.[0]?.total_value;
    }
    const footerData = { total };
    if (!selectedPortfolio?.is_composite) {
      footerData.return = selectedPortfolio?.return;
      footerData.cvar = selectedPortfolio?.cvar;
      footerData.vol = selectedPortfolio?.vol;
    }
    return footerData;
  }, [selectedPortfolio, tabs]);


  const hasComposite = useMemo(() => {
    return portfolioList?.some((i) => i.is_composite);
  }, [portfolioList]);

  useEffect(() => {
    if (portfolioList?.length && selectedRowKeys) {
      const selected = portfolioList?.find((i) => selectedRowKeys === i.id);
      setSelectedPortfolio(selected ?? null);
    }
  }, [selectedRowKeys, portfolioList]);


  const getComposete = () => {
    return portfolioList?.find((i) => i.is_composite);
  };

  useEffect(() => {
    if (state !== 'edit') {
      SessionService.removeItem('portfolioKey');
    }
    const storedPortfolio = SessionService.getItem('portfolioKey');
    if (portfolioList?.length) {
      const defaultSelect = portfolioList.sort((a, b) =>
        textSort(a.created_at, b.created_at, -1),
      )[0];

      if (storedPortfolio) {
        const isCurrentUser = portfolioList.some(
          (i) => i.id === +storedPortfolio,
        );
        if (isCurrentUser) {
          setSelectedRowKeys(+storedPortfolio);
        } else {
          setSelectedRowKeys(
            hasComposite ? getComposete()?.id : defaultSelect?.id,
          );
        }
      } else {
        setSelectedRowKeys(
          hasComposite ? getComposete()?.id : defaultSelect?.id,
        );
      }
    }
  }, [portfolioList, state]);

  useEffect(() => {
    dispatch(getInstrumentsAll({ limit: -1, offset: 0, type: 'cashes-only' }));
    dispatch(getCurrency());

    return () => {
      dispatch(clearCandidates());
    };
  }, []);

  useEffect(() => {
    dispatch(getAllPortfolio(userId));
  }, [userId]);

  useEffect(() => {
    if (njordaURL?.url) {
      setOpenNjordaIFrame(njordaURL?.url);
    }
  }, [njordaURL]);

  const handleOptimise = () => {
    history.push(
      `/accounts/${userId}/optimization/${selectedRowKeys}/opt-settings`,
    );
  };

  const disableOptimise = useMemo(() => {
    if (!selectedRowKeys) return true;

    if (selectedRowKeys) {
      const selectedPortfolio = portfolioList?.find(
        (i) => i.id === selectedRowKeys,
      );
      const isDepr =
        selectedPortfolio?.status === 'ACTIVE_DEPRECATED' ||
        selectedPortfolio?.is_composite ||
        selectedPortfolio?.is_locked;
      return isDepr;
    }
  }, [selectedRowKeys]);

  const handleEdit = () => {
    history.push(`${pathname}/${selectedRowKeys}/holdings`);
  };

  return (
    <div className="portfolio-summary-container">
      {!isLoading && portfolioList && portfolioList?.length === 0 ? (
        <>
          <Row
            justify={'space-between'}
            align={'middle'}
            style={{ marginBottom: '', padding: '24px' }}
          >
            <Col className="client portfolio-counter-wrap">
              <h2 className="client settings-title">{t('PORTFOLIOS')}</h2>
              <span className="portfolio-counter">
                ({portfolioList?.length ?? 0})
              </span>
            </Col>
          </Row>
          <div className="noportfolio-wrapper">
            <div className="noportfolio-container">
              <h2 className="noportfolio-title">{t('NO_PORTFOLIO')}</h2>
              <p className="noportfolio-text">{t('NOPORTFOLIO_TEXT')}</p>
              <ButtonAdd
                title="ADD_PORTFOLIO"
                height="32px"
                onClick={() => setOpenModalSelectNew(true)}
              />
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="component-wrapper" style={{ position: 'relative'}}>
            <Row
              justify={'space-between'}
              align={'middle'}
              style={{ marginBottom: '', padding: '24px' }}
            >
              <Col className="client portfolio-counter-wrap">
                <h2 className="client settings-title">{t('PORTFOLIOS')}</h2>
                <span className="portfolio-counter">
                  ({portfolioList?.length ?? 0})
                </span>
              </Col>
              <Col style={{ display: 'flex', gap: '16px', paddingRight: '48px' }}>
                {selectedPortfolio?.is_composite && (
                  <BattonOptimise
                    height="32px"
                    title={'ANALYZE'}
                    onClick={handleOptimise}
                  />
                )}
                {!selectedPortfolio?.is_composite && (
                  <BattonOptimise
                    disabled={disableOptimise}
                    height="32px"
                    title={'OPTIMISE'}
                    onClick={handleOptimise}
                  />
                )}
                {/* <ClientTopSwitcher
                  text={switchertext}
                  switcher={switcher}
                  handleClick={handleClick}
                /> */}
                <ButtonAdd
                  title="ADD_PORTFOLIO"
                  height="32px"
                  onClick={() => setOpenModalSelectNew(true)}
                />
              </Col>
            </Row>
            <ClientPortfolioList
              portfolios={portfolioList}
              selectedRowKeys={selectedRowKeys}
              setSelectedRowKeys={setSelectedRowKeys}
              isLoading={isLoading}
              theme={theme}
              handleEdit={handleEdit}
              userId={userId}
            />
            <div className="summary-data-wrapper advisot-flow">
              <div className="portfolio-side-wrap advisot-flow">
                <PortfolioTab
                  theme={theme}
                  selectedRowKeys={selectedRowKeys}
                  selectedPortfolio={selectedPortfolio}
                  portfolios={portfolioList}
                  tabs={tabs}
                  setTabs={setTabs}
                />
                <FooterHoldings
                  width={'100%'}
                  totalOnly={selectedPortfolio?.is_composite}
                  data={footerData}
                />
              </div>
              <ClientAssets
                cashes={cashes}
                currencyList={currencyList}
                selectedPortfolio={[selectedPortfolio]}
              />
            </div>
          </div>
        </>
      )}
      <ModalNewPortfolio
        open={openModalNew}
        closeModal={closeModal}
        userId={userId}
      />
      <ModalNewSelectPortfolio
        open={openModalSelectNew}
        closeModal={closeModalSelect}
        setOpenModalNew={setOpenModalNew}
        userId={userId}
      />
      <Modal
        width={700}
        styles={{
          body: {
            padding: '48px 0 0 0',
            height: '80vh',
            backgroundColor: 'transparent',
          },
        }}
        className="modal-portfolio"
        open={openNjordaIFrame}
        onCancel={closeIframe}
        footer={null}
        zIndex={1620}
        destroyOnClose
      >
        <iframe src={openNjordaIFrame} width="100%" height="100%" />
      </Modal>
    </div>
  );
};

export default ClientSummary;

ClientSummary.propTypes = {
  theme: PropTypes.string,
  userId: PropTypes.string,
};

SortArrow.propTypes = {
  direction: PropTypes.string,
};
